import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'frg-chip',
  templateUrl: './chip.fragment.html',
  styleUrls: ['./chip.fragment.scss']
})
export class ChipFragment implements OnInit {

  @Input() public id: string = '';
  public name = this.id;
  @Input() public formGroup: FormGroup;
  @Input() public control: FormControl;
  @Input() public disabled: boolean = true;
  @Input() public isDanger: boolean = false;


  constructor() { }

  ngOnInit(): void {
  }

  public active() {
    if (!this.disabled && this.control) {
      this.control.setValue(!this.control.value);
    }
  }
}
